import {
    Dialog as BaseDialog,
    DialogFooter as BaseFooter,
    DialogType as BaseDialogType,
    IDialogContentProps,
    IDialogProps
} from "@fluentui/react";

export const DialogType = BaseDialogType;

export type DialogProps = IDialogProps;
export type DialogContentProps = IDialogContentProps;

export const DialogFooter = BaseFooter;

export const Dialog = BaseDialog;
